<template>
  <div style="width: 600px;margin: 0 auto;margin-top: 100px;margin-bottom: 100px">
    <p style="text-align: center;font-size: 22px;font-weight: bold">机构登录</p>
     <el-form :model="form" :rules="rules" ref="form" label-width="90px" class="demo-ruleForm" style="margin-left: -100px">
  <el-form-item label="用户名" prop="username">
    <el-input v-model="form.username"></el-input>
  </el-form-item>
   <el-form-item label="密码" prop="password">
    <el-input type="password" v-model="form.password"></el-input>
  </el-form-item>
  <el-form-item>
    <el-button type="primary" @click="checkForm('form')" style="width:100%" @keyup.enter.native="checkForm('form')">登录</el-button>
  </el-form-item>
</el-form>
  </div>

</template>

<script>
import rootPathssb from '@/api/mainApi'
export default {
  name: 'mechanismlogin',
  data () {
    var userName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    var passWord = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    return {
      form: {
        username: '',
        password: ''

      },
      rules: {
        username: [
          { required: true, message: '用户名不能为空', trigger: 'blur' },
          { validator: userName, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { validator: passWord, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm (event) {
      var params = new URLSearchParams()
      let that = this
      params.append('username', this.form.username)
      params.append('password', this.form.password)
      if (that.form.username === '') { alert('请输入手机号') } else if (that.form.password === '') { alert('请输入密码') } else {
        this.$http.post(rootPathssb.rootPath + '/j/signin', params).then(function (response) {
          if (response.data.result === 0) { alert(response.data.msg) };
          if (response.data.result === 1) {
            // localStorage.setItem('JG-Auth', response.data.token)
            window.location.href = '/disclosureshome'
            console.log('cg')
          };

          console.log(response.data)
        })
      }
    },
    checkForm (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.submitForm()
          console.log('成功!')
        } else {
          console.log('提交失败')
          return false
        }
      })
    }

  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/computer/mechanismlogin.vue